import generateFloat from '../generateFloat'

const houseEdge = 0.98

export type CalculateLimboBetResultOptions = {
  serverSeed: string
  clientSeed: string
  nonce: number
}

export default function calculateLimboBetResult(
  options: CalculateLimboBetResultOptions
) {
  const { serverSeed, clientSeed, nonce } = options

  const float = generateFloat({ serverSeed, clientSeed, nonce })

  // Game event translation with houseEdge of 0.99 (1%)
  const floatPoint = (1e8 / (float * 1e8)) * houseEdge

  // Crash point rounded down to required denominator
  const crashPoint = Math.floor(floatPoint * 100) / 100

  // Consolidate all crash points below 1
  const result = Math.max(crashPoint, 1)

  return result
}
